import { FixedMarkerOverrides, FloatingMarker } from 'baseui/map-marker';
import { jobState } from '../../../../storage/jobStates';
import { Marker } from 'react-map-gl/mapbox';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../../hooks/useStyles';
import { isValidPosition } from '../../../../utils/map';

type Props = {
  jobId: string;
};
function JobMarker({ jobId }: Readonly<Props>) {
  const { theme } = useStyles();
  const job = useRecoilValue(jobState(jobId));

  if (!job?.latitude || !job?.longitude) return null;

  const floatingMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
    OuterAnchor: {
      style: { backgroundColor: theme.colors.negative },
    },
  };

  const point = {
    lat: job.latitude,
    lng: job.longitude,
  };

  const isValidPoint = isValidPosition(point.lat, point.lng);

  if (!isValidPoint) return null;

  return (
    <Marker
      latitude={point.lat}
      longitude={point.lng}
    >
      <FloatingMarker
        label={`${job.name}`}
        overrides={floatingMarkerOverrides}
        size="small"
        anchorType="circle"
      />
    </Marker>
  );
}

export default memo(JobMarker);
